<template>
  <div>
    <VideoTrigger>
      <slot />
    </VideoTrigger>
    <GfrDialog
      :show="open"
      transition="slide-down"
      lock-scroll
      placement="center"
      @update:show="onUpdateShow"
      @closed="onClosed"
      :close-icon="{ placement: 'top-out-right' }"
    >
      <template #content>
        <div class="w-248 h-140">
          <ClientOnly>
            <video
              v-if="!isYoutube && open"
              class="h-full w-full"
              :poster="poster"
              controls
              webkit-playsinline
              playsinline
              x5-video-player-type="h5"
            >
              <source :src="url" type="video/mp4" />
            </video>
            <iframe
              v-if="isYoutube && open"
              class="h-full w-full"
              :src="url"
              title=""
              frameborder="0"
              allow="
                accelerometer;
                autoplay;
                clipboard-write;
                encrypted-media;
                gyroscope;
                picture-in-picture;
                web-share;
              "
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
            ></iframe>
          </ClientOnly>
        </div>
      </template>
    </GfrDialog>
  </div>
</template>
<script lang="ts" setup>
import VideoTrigger from '~/components/common/VideoPopup/Trigger.vue'
import { AspectRatio } from '@/components/ui/aspect-ratio'
const open = ref(false)
const props = defineProps({
  url: {
    type: String,
    required: true
  },
  poster: {
    type: String,
    default: ''
  }
})
const triggerOpen = () => {
  open.value = true
}
const triggerClose = () => (open.value = false)

const onUpdateShow = (show: boolean) => {
  open.value = show
}
const onClosed = () => {
  open.value = false
}
const isYoutube = computed(() => props.url.includes('youtube'))
provide('trigger', triggerOpen)
</script>
<style lang="scss" scoped></style>
